<template>
  <div>
    <personal-form
      :title="local.personInformation.checkMoiPersonalInfo"
      :form-model="formModel"
      :required="true"
      :show-prisoner-form="false"
      :show-needs-translator-form="false"
      :always-allow-checking="true"
      :suggested-technical-name="suggestedTechnicalName"
      :view-mode="viewMode"
    ></personal-form>
  </div>
</template>

<script>
import PersonalForm from '@/modules/lawsuit/components/step1/party-types/forms/personal-form';
import { isSaudi } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const {
  mapState: mapLUTState,
  mapGetters: mapLUTGetters,
} = createNamespacedHelpers('LookupsModule');
export default {
  inject: ['$validator'],
  name: 'CheckMoiPersonalInfo',
  components: { PersonalForm },
  props: ['formModel', 'fields', 'viewMode'],
  computed: {
    ...mapLUTState(['socialTypes', 'countries']),
    ...mapLUTGetters(['countriesForNonSaudi']),
    isSaudi() {
      return isSaudi(this.formModel, `socialIdType${this.formattedSuggestedTechnicalName}`);
    },
    selectedCountries() {
      return this.isSaudi ? this.countries : this.countriesForNonSaudi;
    },
    suggestedTechnicalName() {
      return (this.fields || {}).suggestedTechnicalName;
    },
    formattedSuggestedTechnicalName() {
      return this.suggestedTechnicalName ? this.suggestedTechnicalName.charAt(0)
        .toUpperCase() + this.suggestedTechnicalName.slice(1) : '';
    },
    fullName() {
      const firstName = this.formModel[`firstName${this.formattedSuggestedTechnicalName}`] || '';
      const fatherName = this.formModel[`fatherName${this.formattedSuggestedTechnicalName}`] || '';
      const grandFatherName = this.formModel[`grandFatherName${this.formattedSuggestedTechnicalName}`] || '';
      const familyName = this.formModel[`familyName${this.formattedSuggestedTechnicalName}`] || '';

      return `${firstName} ${fatherName} ${grandFatherName} ${familyName}`.trim().replace(/\s+/g, ' ');
    },
    sex() {
      return this.formModel[`sex${this.formattedSuggestedTechnicalName}`];
    },
    nationalityCountryId() {
      return this.formModel[`nationalityCountryId${this.formattedSuggestedTechnicalName}`];
    }
    ,
    socialIdType() {
      return this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`];
    },
    dateOfBirth() {
      return this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`];
    },
  },
  watch: {
    fullName(newFullName) {
      this.$set(this.formModel, `fullName${this.formattedSuggestedTechnicalName}`, newFullName);
    },
    sex() {
      const sexText = this.formModel[`sex${this.formattedSuggestedTechnicalName}`] ? this.formModel[`sex${this.formattedSuggestedTechnicalName}`] == 1 ? 'ذكر' : 'أنثى' : '';
      this.$set(this.formModel, `sexText${this.formattedSuggestedTechnicalName}`, sexText);
    },
    nationalityCountryId() {
      const nationalityText = this.selectedCountries.filter(a => a.id == this.formModel[`nationalityCountryId${this.formattedSuggestedTechnicalName}`])[0]?.name || '';
      this.$set(this.formModel, `nationalityText${this.formattedSuggestedTechnicalName}`, nationalityText);
    },
    socialIdType() {
      const socialTypeText = this.socialTypes.filter(a => a.id == this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`])[0]?.name || '';
      this.$set(this.formModel, `socialTypeText${this.formattedSuggestedTechnicalName}`, socialTypeText);
    },
    dateOfBirth() {
      const age = this.calculateAge(this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`]);
      this.$set(this.formModel, `age${this.formattedSuggestedTechnicalName}`, age);
    },
  },
  methods: {
    calculateAge(dob) {
      if (dob) {
        const birthData = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthData.getFullYear();
        const monthDifference = today.getMonth() - birthData.getMonth();
        // adjust age if the birth month and day haven't occurred yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthData.getDate())) {
          age--;
        }
        return age;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.danger-input {
  ::v-deep .v-label {
    color: red !important;
  }
}
</style>
